<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">PERFIS DE ACESSO</span>
            </b-card-header>
            <b-card-body>
                <b-row>
                    <b-col sm="12" md="6" lg="6" xl="6">
                        <b-alert show>PERFIS ASSOCIADOS</b-alert>
                        <app-tabela
                            idTabela="tblPerfisAcesso"
                            :itens="usuario.perfisAcesso"
                            :campos="camposPerfisAcesso"
                            :itensPorPagina="0"
                        >
                            <template slot="botoes">
                                <b-button-group class="float-right">
                                    <b-button
                                        variant="danger"
                                        v-if="
                                            $temAcessoView('CTRLACS-USR-06-03')
                                        "
                                        @click="
                                            confirmaDesassociarSelecionados()
                                        "
                                        :disabled="
                                            perfisAcessoAssociadosSelecionados.length ===
                                                0
                                        "
                                        >Desassociar selecionados</b-button
                                    >
                                </b-button-group>
                            </template>
                            <template slot="acoes" slot-scope="data">
                                <span
                                    class="text-danger"
                                    v-if="$temAcessoView('CTRLACS-USR-06-03')"
                                    ><i
                                        class="fa fa-trash fa-lg icon-button"
                                        title="Desassociar Perfil de Acesso"
                                        @click.stop="
                                            confirmaDesassociarPerfilAcesso(
                                                data.perfilAcessoId
                                            )
                                        "
                                    ></i
                                ></span>
                            </template>
                            <template
                                slot="perfilAcessoAssociadoSelecao"
                                slot-scope="data"
                                v-if="$temAcessoView('CTRLACS-USR-06-03')"
                            >
                                <b-form-checkbox
                                    :value="data.perfilAcessoId"
                                    v-model="perfisAcessoAssociadosSelecionados"
                                ></b-form-checkbox>
                            </template>
                        </app-tabela>
                    </b-col>
                    <b-col sm="12" md="6" lg="6" xl="6">
                        <b-alert show>PERFIS DISPONÍVEIS</b-alert>
                        <app-tabela
                            idTabela="tblPerfisAcessoDisponiveis"
                            :itens="perfisAcessoDisponiveis"
                            :campos="camposPerfisAcessoDisponiveis"
                            :itensPorPagina="0"
                        >
                            <template slot="botoes">
                                <b-button-group class="float-right">
                                    <b-button
                                        variant="primary"
                                        v-if="
                                            $temAcessoView('CTRLACS-USR-06-02')
                                        "
                                        @click="confirmaAssociarSelecionados()"
                                        :disabled="
                                            perfisAcessoDisponiveisSelecionados.length ===
                                                0
                                        "
                                        >Associar selecionados</b-button
                                    >
                                </b-button-group>
                            </template>
                            <template
                                slot="perfilAcessoDisponivelSelecao"
                                slot-scope="data"
                                v-if="$temAcessoView('CTRLACS-USR-06-02')"
                            >
                                <b-form-checkbox
                                    :value="data.perfilAcessoId"
                                    v-model="
                                        perfisAcessoDisponiveisSelecionados
                                    "
                                ></b-form-checkbox>
                            </template>
                        </app-tabela>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import PerfisAcessoServicos from './../perfisacesso/PerfisAcessoServicos'
import UsuariosServicos from './UsuariosServicos'

export default {
    props: {
        usuario: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            perfisAcessoAssociadosSelecionados: [],
            perfisAcessoDisponiveisSelecionados: [],
            perfisAcesso: [],
            camposPerfisAcesso: [
                {
                    key: 'perfilAcessoAssociadoSelecao',
                    label: ''
                },
                {
                    key: 'codPerfilAcesso',
                    label: 'Código',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descricaoPerfilAcesso',
                    label: 'Perfil Acesso',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            camposPerfisAcessoDisponiveis: [
                {
                    key: 'perfilAcessoDisponivelSelecao',
                    label: ''
                },
                {
                    key: 'codPerfilAcesso',
                    label: 'Código',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descricaoPerfilAcesso',
                    label: 'Perfil Acesso',
                    sortable: true,
                    filterable: true
                }
            ]
        }
    },

    methods: {
        obterPerfisAcesso() {
            this.$store.dispatch('addRequest')
            PerfisAcessoServicos.obterTodos().then(response => {
                if (response) {
                    if (response.success) {
                        this.perfisAcesso = response.data
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        atualizarPerfisAcesso() {
            if (this.usuario.perfisAcesso.length > 0) {
                if (this.perfisAcesso.length > 0) {
                    this.perfisAcessoDisponiveis = this.perfisAcesso.filter(
                        perfil => {
                            return this.usuario.perfisAcesso.every(
                                usuarioPerfil => {
                                    return (
                                        usuarioPerfil.perfilAcessoId !==
                                        perfil.perfilAcessoId
                                    )
                                }
                            )
                        }
                    )
                }
            }
        },

        confirmaAssociarSelecionados() {
            this.$swal({
                title: 'Associação de Perfis de Acesso',
                html: `Confirma a associação dos perfis de acesso selecionados ao usuário <b>${this.usuario.nome}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.associarPerfisAcesso()
                }
            })
        },

        associarPerfisAcesso() {
            this.$store.dispatch('addRequest')
            UsuariosServicos.associarPerfisAcesso({
                usuarioId: this.$route.params.usuarioId,
                perfisAcessoId: this.perfisAcessoDisponiveisSelecionados
            }).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Registro salvo com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.perfisAcessoDisponiveisSelecionados = []
                        this.$emit('obterUsuario')
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmaDesassociarPerfilAcesso(perfilAcessoId) {
            let perfilAcessoTemp = this.usuario.perfisAcesso.filter(item => {
                return item.perfilAcessoId === perfilAcessoId
            })[0]
            this.$swal({
                title: 'Desassociação de Perfil de Acesso',
                html: `Confirma a desassociação do perfil de acesso <b>${perfilAcessoTemp.codPerfilAcesso}</b> do usuário <b>${this.usuario.nome}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.desassociarPerfilAcesso(perfilAcessoId)
                }
            })
        },

        desassociarPerfilAcesso(perfilAcessoId) {
            this.$store.dispatch('addRequest')
            UsuariosServicos.desassociarPerfilAcesso({
                usuarioId: this.$route.params.usuarioId,
                perfilAcessoId: perfilAcessoId
            }).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Registro excluído com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('obterUsuario')
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmaDesassociarSelecionados() {
            this.$swal({
                title: 'Desassociação de Perfils de Acesso',
                html: `Confirma a desassociação dos perfis de acesso selecionados do usuário <b>${this.usuario.nome}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.desassociarPerfisAcesso()
                }
            })
        },

        desassociarPerfisAcesso() {
            this.$store.dispatch('addRequest')
            UsuariosServicos.desassociarPerfisAcesso({
                usuarioId: this.$route.params.usuarioId,
                perfisAcessoId: this.perfisAcessoAssociadosSelecionados
            }).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Registros desassociados com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.perfisAcessoAssociadosSelecionados = []
                        this.$emit('obterUsuario')
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {
        this.obterPerfisAcesso()
    },

    computed: {
        perfisAcessoDisponiveis() {
            if (this.usuario.perfisAcesso) {
                return this.perfisAcesso.filter(perfil => {
                    return this.usuario.perfisAcesso.every(usuarioPerfil => {
                        return (
                            usuarioPerfil.perfilAcessoId !==
                            perfil.perfilAcessoId
                        )
                    })
                })
            }
        }
    }
}
</script>
